<div class="op-document-notification" *transloco="let t">
	<div class="notification">
		<ng-content></ng-content>
	</div>
</div>
